import React, { useState, useEffect,useRef } from 'react';
import './StockTicker.css';



const StockTicker = () => {
  const[open,setOpen] = useState(false);
  const[category,setCategory]= useState("Top Securities");
  const[selectedStock, setSelectedStock] = useState(null);
  const dropdownRef = useRef(null);

  

  const[stocks, setStocks] = useState([
    { name: 'S&P 500 ', value: '6,902.05', change: ' +0.64%', positive: true },
    { name: 'Nasdaq ', value: '23,395.82 ', change: ' +0.69%', positive: true },
    { name: 'B500 ', value: '2,498.17 ', change: ' +0.66%', positive: true },
    { name: 'US 10 Yr ', value: '4.18 ', change: ' +0.00%',positive:true },
    { name: 'Crude Oil ', value: '57.96 ', change: ' -0.62%', negative: true },
    { name: 'FTSE 100 ', value: '10,004.57 ', change: ' +0.54%', positive: true },
    // { name:'GOLD', value:'4,641.20', change:'+0.52%', positive:true},
    // { name:'EUR/USD', value:'1.10', change:'-0.14%', negative:true},
    // { name:'POUND/DOLLAR', value:'1.25', change:'-0.10%', negative:true},
  ]);
  
    useEffect(() => {
    const interval = setInterval(() => {
      setStocks(prev =>
        prev.map(stock => {
          if (!stock.positive && !stock.negative) return stock;

          const current = parseFloat(stock.value.replace(/,/g, ""));
          const changeAmount = (Math.random() - 0.5) * current * 0.01;
          const newValue = current + changeAmount;

          const formatted =
            newValue > 1000
              ? newValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              : newValue.toFixed(2);

          const pct = ((newValue - current) / current * 100).toFixed(2);

          return {
            ...stock,
            value: formatted,
            change: `${pct > 0 ? '+' : ''}${pct}%`,
            positive: pct > 0,
            negative: pct < 0
          };
        })
      );
    }, 30000);

   return () => clearInterval(interval);
  }, []);

useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return(
    <div className="topic-tags">
      <div className="container">
        <div className="ticker-row">
          <div className="ticker-category-dropdown" ref={dropdownRef}>
            <button
            className="ticker-category-button"
            onClick={()=> setOpen(prev => !prev)}
            >
              {category}
              <span className={`dropdown-chevron ${open ? "open" : ""}`}>
              </span>
            </button>


            {open && (
              <div className="ticker-category-menu">
                {
                  ["Top Securities","Market Indices","Rates & Bonds"].map(
                    (item) => (
                      <button
                      key = {item}
                      className={`ticker-category-item ${
                        category === item ? "active" : ""}`}
                        onClick = {()=> {
                          setCategory(item);
                          setOpen(false);
                        }}
                        >
                          {item}
                        </button>
                    )
                  )}
                </div>
            )}
          </div>

          <div className="tags-wrapper">
          {stocks.map((stock, index) => (
            <a 
              href="#" 
              className={`tag ${selectedStock === index ? 'active' : ''}`} 
              key={index}
              onClick={(e) => {
                e.preventDefault();
                setSelectedStock(index);
              }}
            >
              <span className="tag-name">{stock.name}</span>
              <span className="tag-value">{stock.value}</span>
              <span
                className={`tag-change ${
                  stock.positive ? 'positive' : stock.negative ? 'negative' : ''
                }`}
              >
                {stock.change}
              </span>
            </a>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockTicker;

          


